import { SelectedRestaurantReservation } from '@msc-b2c/interfaces/interfaces';

/**
 * Stable fingerprint for cart recap “dirty” checks (normalizes date/time formatting).
 */
export const fingerprintDiningReservationList = (
  reservations: readonly SelectedRestaurantReservation[]
): string => {
  return reservations
    .map((r) => {
      const date = (r.date ?? '').trim().split('T')[0];
      const raw = (r.time ?? '').trim();
      const timeMatch = /^(\d{1,2}:\d{2})(?::\d{2})?/.exec(raw);
      const time = timeMatch ? timeMatch[1] : raw;
      return `${r.restaurantCode}|${date}|${time}`;
    })
    .join('||');
};
